"use client";

import { useEffect, useState } from "react";

const LG_BREAKPOINT = 1024;

/**
 * Returns true when viewport width is >= 1024px (Tailwind lg breakpoint).
 */
export function useIsLg(): boolean {
  const [isLg, setIsLg] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${LG_BREAKPOINT}px)`);
    const handler = () => setIsLg(mq.matches);
    handler(); // set initial value
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isLg;
}
